import { BaseController } from '../../common/base/controller';

export class BankInfoController extends BaseController {
  constructor(
    controllerService,
    $scope,
    SearchBankTemplate,
    padContactService,
    clipboard,
    notificationService
  ) {
    'ngInject';
    super({
      controllerService,
      $scope,
      SearchBankTemplate,
      padContactService,
      clipboard,
      notificationService,
    });
  }

  $onInit() {
    /*
    this.searchSuggest = {
      templateUrl: this.SearchBankTemplate,
      editable: false,
      delay: 200,
    };*/
    this.blzRegex = new RegExp('^[0-9]{3}?[0-9]{3}?[0-9]{2}$');
    this.ibanRegex = new RegExp('^[A-Z]{2}(?:[ ]?[0-9]){18,20}$');

    this.$scope.$watch(
      'vm.searchTerm',
      (newVal, oldVal) => {
        this.selectedBank = null;
        if (newVal) {
          const term = newVal.replace(/ /g, '');
          if (this.blzRegex.test(term) || this.ibanRegex.test(term)) {
            this.padContactService.findByBLZOrIban(term).then(
              (r) => {
                this.selectedBank = r.data;
              },
              (r) => {
                if (r.status === 404) {
                  this.error('app.bankInfo.notFound');
                }
              }
            );
          }
        }
      },
      true
    );
  }

  get showDetails() {
    const show =
      this.selectedBank &&
      this.selectedBank.contact &&
      this.selectedBank.contact.name &&
      (this.selectedBank.contact.address || this.selectedBank.contact.postcode);
    return show;
  }

  get showBankName() {
    return (
      this.selectedBank &&
      this.selectedBank.contact.name != this.selectedBank.bankName
    );
  }

  copyToClipboard() {
    this.clipboard.copyText(this.selectedBank.kwhEmail);
    this.notificationService.success(
      this.$translate.instant('app.bankInfo.copiedToClipboard')
    );
  }

  /*
  searchSuggestSource($viewValue = '') {
    const term = $viewValue.replace(/ /g, '');
    return new Promise((resolve, reject) => {
      if (this.blzRegex.test(term)) {
        this.padContactService.findByBLZ(term).then(
          (r) => {
            resolve([r.data]);
          },
          (r) => {
            this.error('app.bankInfo.notFound');
            return resolve([]);
          }
        );
      } else {
        return resolve([]);
      }
    });
  }

  searchSuggestSelect($item) {
    this.selectedBank = $item;
  }
  */
}
